<template>
  <transition name="fade">
    <div
      v-if="visible"
      :class="type"
      class="toast">
      {{ message }}
    </div>
  </transition>
</template>

<script lang="ts">
  import { defineComponent, ref } from 'vue'

  export default defineComponent({
    name: 'Toast',
    setup() {
      const visible = ref(false)
      const message = ref('')
      const type = ref('info')

      const show = (opts: { message: string; type: string; delay?: number }) => {
        const { message: msg, type: t, delay = 3000 } = opts
        message.value = msg
        type.value = t
        visible.value = true

        setTimeout(() => {
          visible.value = false
        }, delay)
      }

      return {
        visible,
        message,
        type,
        show
      }
    }
  })
</script>

<style scoped>
  .toast {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    padding: 16px 24px;
    line-height: 1;
    border-radius: 5px;
    z-index: 100000;
  }

  .toast.info {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .toast.success {
    color: #4caf50;
    background-color: rgba(76, 175, 80, 0.16);
  }

  .toast.error {
    color: #f44336;
    background-color: rgba(244, 67, 54, 0.16);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
